

import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Footerwithdr from "../../../common_components/Footerwithdr";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { visitorTaxInvoiceList_action, sendVisitorInvoiceMail_action } from "../../../actions/admin_module_action/visitor_tax_invoice_action/visitor_tax_invoice_action";
import {
    countryActionId,
    downloadReport,
    exhibitorActionId,
    exhibitorTypeActionId,
    fetchAuthReport,
    fetchDocReport,
    stateActionId,
    taxInvoiceDoc,
    taxInvoiceMFDoc,
    toastError,
    toastSuccess,
} from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import moment from "moment";
import Workbook from 'react-excel-workbook'
import { fill_action } from "../../../actions/fillCombo_action";
import { axiosPost } from "../../../react_axios/Axios";
import Modal from "react-modal";
import { emailValidator } from "../../../utils/Validator";
import { elements } from "chart.js";
import axios from "axios";

class VisitorTaxInvoiceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            VisitorRegistrationNo: "",
            isLoading: false,
            isOpen: false,
            UserID: "",
            ExhibitionID: "",
            ReceiptID: "",
            AccountID: "",
            ReceiptNo: "",
            State: "",
            CountryName: "",
            taxInvoiceData: [],
            CompanyName: "",
            Name: "",
            ReceiptNo: "",
            ReceiptDate: "",
            ProformaInvoice_No: "",
            ReceivedAmount: "",
            currentPage: 1,
            countryList: [],
            stateList: [],
            exhibitorTypeList: [],
            exhibitorFillList: [],
            exhibitorFillId: "",
            exhibitorTypeId: "",
            stateId: "",
            countryId: "",
            allSelected: false,
            checkboxStates: [],
            excelList: [],
            loginAccesslist: [],
            TaxInvoice_No: "",
            taxInvoiceId: "",
            exhVisitorID: '',
            additionalEmail: "",
            additionalEmailErr: ""
        };
        this.getTaxInvoiceList = this.getTaxInvoiceList.bind(this);
        this.taxInvoiceRecords = this.taxInvoiceRecords.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.handleView = this.handleView.bind(this)
        this.onSendTaxInvoice = this.onSendTaxInvoice.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.invoiceMail = this.invoiceMail.bind(this)
        this.sendTaxInvoice = this.sendTaxInvoice.bind(this)
        this.getDownloadAccess = this.getDownloadAccess.bind(this)
        this.getSendAccess = this.getSendAccess.bind(this)
        this.sendVisitorTaxInvoice = this.sendVisitorTaxInvoice.bind(this)
    }
    componentDidMount() {
        this.getTaxInvoiceList();
        // this.getFillList(exhibitorActionId, "", "", "", "", "");
        // this.getFillList(exhibitorTypeActionId, "", "", "", "", "");
        // this.getFillList(stateActionId, "", "", "", "", "");
        // this.getFillList(countryActionId, "", "", "", "", "");
        const { taxInvoiceData } = this.state;
        const initialCheckboxStates = new Array(taxInvoiceData.length).fill(false);
        this.setState({
            checkboxStates: initialCheckboxStates,
            loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist']
        });
    }

    async getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true });
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID == exhibitorActionId) {
                        this.setState({ exhibitorFillList: data.data, isLoading: false });
                        console.log("exhibitorActionId", data.data);
                    }
                    if (actionID == exhibitorTypeActionId) {
                        this.setState({ exhibitorTypeList: data.data, isLoading: false });
                        console.log("exhibitorTypeActionId", data.data);
                    }
                    if (actionID == stateActionId) {
                        this.setState({ stateList: data.data, isLoading: false });
                        console.log("stateActionId", data.data);
                    }
                    if (actionID == countryActionId) {
                        this.setState({ countryList: data.data, isLoading: false });
                        console.log("countryActionId", data.data);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    getTaxInvoiceList() {
        const { CompanyName, VisitorRegistrationNo, TaxInvoice_No } =
            this.state;
        this.setState({ isLoading: true });
        this.props
            .visitorTaxInvoiceList_action(
                VisitorRegistrationNo, CompanyName, TaxInvoice_No)
            .then((data) => {
                if (data.error != 1) {
                    var list = [...data.data]
                    list.map((item, index) => {
                        item.isSelect = 0;
                    });
                    // data.data = data.data.map(item => ({ ...item, Is_checked: 0 }));
                    console.log("from UI Client", list);
                    this.setState({
                        taxInvoiceData: list,
                        allSelected: false,
                        isLoading: false,
                    });
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    checkedBoxList(checkedItems, index, e) {
        const { taxInvoiceData, excelList } = this.state;
        const list = [...taxInvoiceData];
        const event = e.target.checked;

        if (event == true) {
            checkedItems.forEach((data, i) => {
                if (i === index) {
                    data.isSelect = 1;

                    excelList.push(data)
                }
            });
            // this.setState({
            //   taxInvoiceData: list,
            // });
        } else {
            checkedItems.forEach((data, i) => {
                if (i === index) {
                    data.isSelect = 0;
                }
            });
            this.setState({
                // taxInvoiceData: list,
                excelList: []
            });
        }
        console.log("list", list);
        const checkboxDisable = list.some((item) => item.isSelect == 1);

        // debugger
        if (checkboxDisable) {
            this.setState({ isDisable: false });
        } else {
            this.setState({ isDisable: true });
        }

        const allSelectedChecked = list.every((item) => item.isSelect == 1);

        // debugger
        if (allSelectedChecked) {
            this.setState({ allSelected: true });
        } else {
            this.setState({ allSelected: false });
        }
    }

    allSelectedCheckbox(e) {
        const { taxInvoiceData, excelList } = this.state;

        if (e.target.checked == true) {
            taxInvoiceData.map((data) => {
                data.isSelect = 1;
            });
            this.setState({ allSelected: true, excelList: taxInvoiceData });
        } else {
            taxInvoiceData.map((data) => {
                data.isSelect = 0;
            });
            this.setState({ allSelected: false, excelList: [] });
        }
    }

    navigateToEdit(ExhibitionID, ReceiptID) {
        this.props.navigate("/taxinvoiceedit", {
            state: {
                ExhibitionID: ExhibitionID,
                ReceiptID: ReceiptID
            }
        });
    }

    invoiceMail() {
        const { taxInvoiceData, additionalEmail } = this.state
        const IsChecked = taxInvoiceData.some((item) => item.isSelect == 1);
        var IDlist = []
        taxInvoiceData.length > 0 && taxInvoiceData.map(item => {
            if (item.isSelect == 1) {
                if (item.FormID == null) {
                    if (!IDlist.includes(item.TaxInvoiceID)) {
                        IDlist.push(item.TaxInvoiceID)
                    }
                } else {
                    taxInvoiceData.length > 0 && taxInvoiceData.map(item2 => {
                        if (item2.FormID == null) {
                            if (item.ExhRegistrationID == item2.ExhRegistrationID) {
                                if (!IDlist.includes(item2.TaxInvoiceID)) {
                                    IDlist.push(item2.TaxInvoiceID)
                                }
                            }
                        }
                    })
                }
            }
        })
        if (IsChecked) {
            const list = []
            IDlist.length > 0 && IDlist.map((data) => {
                list.push(
                    {
                        'TaxInvoiceID': data,
                        'FormID': null
                    }
                )
            })
            console.log(taxInvoiceData.filter((item) => item.isSelect == 1), list)
            this.setState({ isLoading: true })
            this.props.invoiceMail_action(list, additionalEmail)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        toastSuccess("InvoiceMail send successfully!")
                        this.getTaxInvoiceList()
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError("Please select atleast 1 tax invoice")
        }
    }

    updateItem(item) {
        this.setState({ currentPage: item });
    }

    taxInvoiceRecords(taxInvoiceData) {
        const { allSelected, checkboxStates } = this.state;
        return (

            <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                <thead class="table-light">
                    <tr>
                        <th className="text-center">
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={(e) => this.allSelectedCheckbox(e)}
                            />
                        </th>
                        <th className="text-center">Visitor Reference No</th>
                        <th>Visitor Company</th>
                        <th>Visitor Name</th>
                        <th className="text-center">Invoice No</th>
                        <th className="text-center">Date</th>
                        <th className="text-center">Amount</th>
                        <th className="text-center">Type</th>
                        <th>View</th>
                        {this.getSendAccess() &&
                            <th>Action</th>
                        }
                        {/* <th>Send</th> */}
                    </tr>
                </thead>
                <tbody>
                    {taxInvoiceData.length > 0 ? (
                        taxInvoiceData.map((data, index) => (
                            <tr key={index}>
                                <td className="text-center">
                                    <input
                                        type="checkbox"
                                        checked={data.isSelect}
                                        onChange={(e) => this.checkedBoxList(taxInvoiceData, index, e)}
                                    />
                                </td>
                                <td className="text-center">{data.VisitorRegistrationNo}</td>
                                <td>{data.CompanyName}</td>
                                <td>{data.VisitorName}</td>
                                <td>{data.TaxInvoice_No}</td>
                                <td className="text-center">
                                    {data.TaxInvoice_Date
                                        ? moment(data.TaxInvoice_Date).format("DD-MM-YYYY")
                                        : null}
                                </td>
                                <td className="text-center">
                                    {data.Total_Payable?.toLocaleString("en-IN")}
                                </td>
                                <td className="text-center">{data.ServiceName}</td>
                                <td className="text-center">

                                    {this.getDownloadAccess() && <i className="fa fa-eye grid-icon" aria-hidden="true"
                                        onClick={e => this.handleView(e, data.TaxInvoiceID)}
                                    />}
                                </td>
                                {(this.getSendAccess() && data.FormID == null) &&
                                    <td className="text-center">
                                        <button className="btn rounded-0 btn-secondary" style={{ padding: "2px" }}
                                            onClick={(e) => this.onSendTaxInvoice(data.TaxInvoiceID, data.ExhVisitorID)}
                                        >Send</button>
                                    </td>
                                }
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8">No data available</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    onCreateExcel() {
        const { taxInvoiceData } = this.state

        const checkboxDisable = taxInvoiceData.some(item => item.isSelect == 1)

        var listData = []
        taxInvoiceData.length > 0 && taxInvoiceData.map((item, index) => {
            var mapData1 = {
                'SR No': index + 1,

            }
            var finalMapData = { ...mapData1, ...item }
            listData.push(finalMapData)
        })

        var excludeKeys = [
            'ExhibitionID', 'TaxInvoiceID'
        ]

        // Function to remove keys from objects
        function removeKeysFromObjects(arr, keys) {
            return arr.map((obj) => {
                const newObj = { ...obj }; // Create a new object to avoid modifying the original
                keys.forEach((key) => delete newObj[key]); // Remove specified keys from the new object
                return newObj;
            });
        }

        // Remove keys from the array of objects
        const newArray = removeKeysFromObjects(listData, excludeKeys);

        var rowData = [];
        var columnArray = []

        // for column data 
        newArray.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, index) => {
                    columnArray.push(key)
                })
            }
        })

        // for row data
        if (checkboxDisable) {
            newArray.map((data, index) => {
                if (data.isSelect == 1) {
                    rowData.push(data)
                }
            })
        } else {
            newArray.map((data, index) => {
                rowData.push(data)
            })
        }


        return (
            <div className="row text-center" >
                <Workbook filename="Tax_Invoice_List.xlsx" element={
                    <button type="button" className="btn rounded-1 btn-aqua"
                        disabled={!this.getDownloadAccess()}>
                        Download EXCEL
                    </button>
                }>
                    <Workbook.Sheet data={rowData} name="Sheet A">
                        {columnArray.map((value, index) =>
                            <Workbook.Column label={value} value={value} />
                        )
                        }
                    </Workbook.Sheet>
                </Workbook>
            </div>
        );
    }

    handleSearch() {
        this.setState({ currentPage: 1 })
        this.getTaxInvoiceList()
    }

    clearFilters() {
        this.setState(
            {
                CompanyName: "",
                VisitorRegistrationNo: "",
                TaxInvoice_No: ""
            },
            () => {
                this.getTaxInvoiceList();

            }
        );
    }

    // handleView = async (id, FormID, service) => {
    //     this.setState({ isLoading: true });
    //     try {
    //         var list = [];
    //         var mapData = {}
    //         if (FormID != null) {
    //             const mapdata1 = {
    //                 "ParameterName": "@FormID",
    //                 "ParameterValue": FormID,
    //                 "ParameterDataType": "int"
    //             }
    //             list.push(mapdata1);
    //             const mapdata2 = {
    //                 "ParameterName": "@FormType",
    //                 "ParameterValue": service,
    //                 "ParameterDataType": "VARCHAR"
    //             }
    //             list.push(mapdata2);
    //             mapData = {
    //                 report_name: taxInvoiceMFDoc,
    //                 parameter_details: list,
    //             };
    //         } else {
    //             const mapdata1 = {
    //                 "ParameterName": "@TaxInvoiceID",
    //                 "ParameterValue": id,
    //                 "ParameterDataType": "int"
    //             };
    //             list.push(mapdata1);
    //             mapData = {
    //                 "report_name": taxInvoiceDoc,
    //                 "parameter_details": list
    //             };
    //         }
    //         console.log("xxxxxxxxxxxxxxxxxxxxx", mapData)
    //         const res = await axiosPost(fetchAuthReport, mapData);
    //         this.setState({ isLoading: false });

    //         if (res != null) {
    //             var url = `${downloadReport}?SessionIdentifier=${res}`;
    //             const win = window.open(url, '_blank', 'noopener,noreferrer');
    //             if (win != null) {
    //                 win.focus();
    //             }
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     }
    // }

    handleView = async (e, id) => {
        this.setState({ isLoading: true })
        try {

            var list2 = [
                {
                    ParameterName: "@TaxInvoiceID",
                    ParameterValue: id,
                    ParameterDataType: "int",
                }
            ]

            var mapData2 = {
                user_id: '',
                report_name: "VisitorTaxInvoice.rpt",
                report_file_name: `taxinvoice${id}`,
                config_id: 0,
                parameter_details: list2,
            }
            console.log("xxxxxxxxxxxxxxxxxxxxx", mapData2)
            const res = await axiosPost(fetchAuthReport, mapData2);
            this.setState({ isLoading: false });

            if (res != null) {
                var url = `${downloadReport}?SessionIdentifier=${res}`;
                const win = window.open(url, '_blank', 'noopener,noreferrer');
                if (win != null) {
                    win.focus();
                }
            }
        } catch (err) {
            this.setState({ isLoading: false })
            toastError("something went wrong")
        }
    }

    // On Generate Hall No Stall No 
    onSendTaxInvoice(id, exhid) {
        this.setState({ taxInvoiceId: id, exhVisitorID: exhid })
        this.toggleModal()
    }

    // Modal Toggle 2
    toggleModal() {
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
    }

    // On Send Tax Invoice
    sendTaxInvoice() {
        const { isOpen, additionalEmail, taxInvoiceData, taxInvoiceId, additionalEmailErr } = this.state;
        const emailError = emailValidator(additionalEmail);
        var FormID = null
        taxInvoiceData.forEach((data) => {
            if (data.TaxInvoiceID == taxInvoiceId) {
                FormID = data.FormID
            }
        })

        if (additionalEmail !== "" && emailError !== "") {
            this.setState({ additionalEmailErr: emailError });
            toastError("Please Enter a Proper Email Address");
            return;
        }

        this.setState({ additionalEmailErr: "", isLoading: true });

        if (additionalEmailErr === "") {
            const list = [{ TaxInvoiceID: taxInvoiceId, FormID: FormID }];
            this.props
                .invoiceMail_action(list, additionalEmail)
                .then((data) => {
                    if (data.error !== 1) {
                        this.setState({
                            isLoading: false,
                            taxInvoiceId: "",
                            isOpen: !isOpen,
                        });
                        toastSuccess("Tax Invoice Sent Successfully");
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                });
        }
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '45');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '45');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }

    downloadTaxInvoicesList = async (id) => {
        this.setState({ isLoading: true });

        try {
            let list = [];
            let mapData = {};
            list.push(
                {
                    ParameterName: "@TaxInvoiceID",
                    ParameterValue: id,
                    ParameterDataType: "int",
                }
            );

            mapData = {
                user_id: '',
                report_name: "VisitorTaxInvoice.rpt",
                report_file_name: `taxinvoice${id}`,
                config_id: 0,
                parameter_details: list,
            }

            console.log("Request Payload:", mapData);

            const res = await axios.post(
                fetchDocReport,
                mapData,
                { responseType: "arraybuffer" }
            )

            const base64 = btoa(
                new Uint8Array(res.data)
                    .reduce((data, byte) => data + String.fromCharCode(byte), "")
            );

            this.handleExportPDF(base64, "TaxInvoice");

        } catch (err) {
            console.error("Error downloading Tax Invoice:", err);
        } finally {
            this.setState({ isLoading: false });
        }
    };


    handleExportPDF = (base64Data, fileName) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length)
            .fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    downloadTaxInvoices() {
        const { taxInvoiceData } = this.state

        const IsChecked = taxInvoiceData.some((item) => item.isSelect == 1);
        if (IsChecked) {
            taxInvoiceData.forEach(async (elements) => {
                if (elements.isSelect) {
                    await this.downloadTaxInvoicesList(elements.TaxInvoiceID)
                }
            })
        } else {
            toastError("Please select atleast 1 tax invoice")
        }
    }

    sendVisitorTaxInvoice(mode, id) {
        const {
            isLoading, Name, ProformaInvoice_No, ReceiptDate, ReceiptNo, ReceivedAmount, taxInvoiceData, currentPage, exhibitorFillId,
            exhibitorTypeId, stateId, countryId, exhibitorFillList, exhibitorTypeList, stateList, countryList, CompanyName, VisitorRegistrationNo,
            TaxInvoice_No, isOpen, additionalEmail, additionalEmailErr, taxInvoiceId, exhVisitorID
        } = this.state;

        var VisitorList = []
        var TaxInvoiceList = []
        if (mode == 0) {
            var selectedVisitors = taxInvoiceData.length > 0 && taxInvoiceData.filter((item) => item.isSelect)
            selectedVisitors.length > 0 && selectedVisitors.map((element) => {
                VisitorList.push(element.ExhVisitorID)
                TaxInvoiceList.push(element.TaxInvoiceID)
            })
            if (VisitorList.length == 0) {
                toastError("Please select atleast 1 record")
                return
            }
        } else {
            VisitorList.push(exhVisitorID)
            TaxInvoiceList.push(taxInvoiceId)
        }
        this.setState({ isLoading: true })
        this.props.sendVisitorInvoiceMail_action(VisitorList, TaxInvoiceList, additionalEmail)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess("InvoiceMail send successfully!")
                    this.getTaxInvoiceList()
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const {
            isLoading, Name, ProformaInvoice_No, ReceiptDate, ReceiptNo, ReceivedAmount, taxInvoiceData, currentPage, exhibitorFillId,
            exhibitorTypeId, stateId, countryId, exhibitorFillList, exhibitorTypeList, stateList, countryList, CompanyName, VisitorRegistrationNo,
            TaxInvoice_No, isOpen, additionalEmail, additionalEmailErr
        } = this.state;
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = taxInvoiceData.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(taxInvoiceData.length / recordsPerPage);
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <AdminDrawer />
                    <div
                        className={
                            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
                                ? "with-dr-container"
                                : "with-dr-container com-height"
                        }
                    >
                        <div className="main-content app-content">
                            <div className="main-container">
                                <div class="row m-0">
                                    <div class="breadcrumb-scroll-fixed">
                                        <h6 className="mb-0 p-2 text-white">Tax Invoice List</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="row m-0">
                                <div className="admin-top-space pt-0 d-flex">
                                    <div className="col-md-4 pr-0">
                                        <label htmlFor="validationCustom03">Company</label>
                                        <input type="text" className="form-control" value={CompanyName}
                                            onChange={(e) =>
                                                this.setState({
                                                    CompanyName: e.target.value,
                                                })
                                            } />
                                    </div>
                                    <div className="col-md-4 pr-0">
                                        <label htmlFor="validationCustom03">Visitor Reference No</label>
                                        <input type="text" className="form-control" value={VisitorRegistrationNo}
                                            onChange={(e) =>
                                                this.setState({
                                                    VisitorRegistrationNo: e.target.value,
                                                })
                                            } />
                                    </div>
                                    <div className="col-md-4 pr-0">
                                        <label htmlFor="validationCustom03">Visitor Tax Invoice No</label>
                                        <input type="text" className="form-control" value={TaxInvoice_No}
                                            onChange={(e) =>
                                                this.setState({
                                                    TaxInvoice_No: e.target.value,
                                                })
                                            } />
                                    </div>
                                </div>
                            </div>
                            <div className="row m-0 p-0 my-2">
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn btn-aqua me-2"
                                        onClick={() => this.handleSearch()}
                                    >
                                        Search
                                    </button>
                                    <button
                                        className="btn btn-gray me-2 "
                                        onClick={() => this.clearFilters()}
                                    >
                                        Clear
                                    </button>
                                    <button
                                        className="btn btn-aqua me-2"

                                        disabled={!this.getSendAccess()}
                                        onClick={() => this.sendVisitorTaxInvoice(0)}
                                    >
                                        Send
                                    </button>
                                    {this.onCreateExcel()}
                                    <button
                                        disabled={!this.getDownloadAccess()}
                                        className="btn btn-aqua ms-2"
                                        onClick={() => this.downloadTaxInvoices()}
                                    >
                                        Download Tax Invoices
                                    </button>
                                </div>
                            </div>
                            <div class="table-responsive px-1 sticky-table-wrapper service-list-grid mx-2">
                                {this.taxInvoiceRecords(currentRecords)}
                                {taxInvoiceData.length > 0 ? (
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={this.updateItem}
                                    />
                                ) : (
                                    <></>
                                )}
                            </div>

                        </div>
                    </div>
                    {
                        JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                        <Footerwithdr />
                    }
                    <Modal isOpen={isOpen} onRequestClose={(e) => this.toggleModal(e)}>
                        <div
                            className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                            id="detail"
                        // tabIndex={-1}
                        // aria-labelledby="detailLabel"
                        // aria-hidden="true"
                        >
                            <div className="modal-dialog modal-md">
                                <div className="modal-content modal-width">
                                    <div className="modal-header p-2">
                                        <h5 className="modal-title" id="detailLabel">
                                            <strong>Send Tax Invoice</strong>
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close pt-6"
                                            data-bs-dismiss="modal"
                                            style={{ fontSize: 12 }}
                                            aria-label="Close"
                                            onClick={(e) => this.toggleModal(e)}
                                        />
                                    </div>
                                    <div className="modal-body p-2">
                                        <div className="d-flex">
                                            <div className="col-xl-11">
                                                <label className="text-left">Email Address</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={additionalEmail}
                                                    onChange={(e) => this.setState({ additionalEmail: e.target.value, additionalEmailErr: "" })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{additionalEmailErr}</span>}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="modal-footer p-2">
                                        <button
                                            type="button"
                                            className="btn btn-gray"
                                            data-bs-dismiss="modal"
                                            onClick={(e) => this.sendVisitorTaxInvoice(1)}
                                        >
                                            Send
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-gray"
                                            data-bs-dismiss="modal"
                                            onClick={(e) => this.toggleModal(e)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </>

            </>
        );
    }
}
export default withRouter(
    connect(null, { visitorTaxInvoiceList_action, sendVisitorInvoiceMail_action })(VisitorTaxInvoiceList)
);
